import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type GetSelectedItemFunction = (item: FcpSelectItem) => FcpSelectItem | string;
type SetSelectedItemFunction = (item: FcpSelectItem | string, items: FcpSelectItem[]) => FcpSelectItem;

@Component({
    selector: 'fcp-select',
    templateUrl: './fcp-select.component.html',
    styleUrls: ['./fcp-select.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FcpSelectComponent
        }
    ],
    standalone: false
})
export class FcpSelectComponent implements ControlValueAccessor {
    @Input() items: FcpSelectItem[] = [];

    @Input() getSelectedItemFunction: GetSelectedItemFunction = (item) => item;
    @Input() setSelectedItemFunction: SetSelectedItemFunction = (item) => item as FcpSelectItem;

    selectedItem: FcpSelectItem = null;
    isOpened = false;

    onChange = (type) => {};
    onTouched = () => {};
    disabled = false;

    toggleMenu() {
        this.isOpened = !this.isOpened;
    }

    handleClose() {
        this.isOpened = false;
    }

    clickedOutside() {
        this.isOpened = false;
    }

    handleClick(item: FcpSelectItem) {
        this.selectedItem = item;
        this.onChange(this.getSelectedItemFunction(this.selectedItem));
        this.handleClose();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(obj: any): void {
        this.selectedItem = this.setSelectedItemFunction(obj, this.items);
    }
}

export interface FcpSelectItem {
    label: string;
    value: string;
}
